export const ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST';
export const ADD_GROUP_FAILURE = 'ADD_GROUP_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/redux/constants/add_group.constants.js